export default import.meta.ROLLUP_FILE_URL_TX5a1iViCylaCWPFSCQG2w;